var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9717 20.0469H0.97168V14.0469L4.97168 10.0469L0.97168 6.04688V0.046875H12.9717V6.04688L8.97168 10.0469L12.9717 14.0469M2.97168 5.54688L6.97168 9.54688L10.9717 5.54688V2.04688H2.97168M6.97168 10.5469L2.97168 14.5469V18.0469H10.9717V14.5469M8.97168 16.0469H4.97168V15.2469L6.97168 13.2469L8.97168 15.2469V16.0469Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f209c2d1627697f942deca10253663bc.svg";
export { ForwardRef as ReactComponent };